import {ImageRequestParams} from "../../../../infrastructure/models/params/image-request-params";
import {BaseMetadataModel} from "../../../../infrastructure/models/base-metadata-model";
import {IMAGE_DEFAULT_FORMATS} from "../../../app/consts";

export class SocialLogoRequestParams extends ImageRequestParams {
  id: Number;

  constructor(socialName: String, metaData: BaseMetadataModel, width: Number = 32, height: Number = 32) {
    super({resourceName: 'Website/Social', metaData, width, height});

    this.socialName = socialName;
    this.ratio = 3;
    this.version = 3;
  }

  toString(): String {
    const url = super.toString() + '/' + this.socialName;

    return url;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
